import axiosInstance from './api';

// Owner sharing calls never carry the company-view header: authority comes from company membership.
const options = { skipAutoLocation: true, skipCompanyScope: true };
const base = orgId => `/owner-sharing/${encodeURIComponent(orgId)}`;

export const ownerSharingEnabled = () => process.env.REACT_APP_OWNER_SHARING_ENABLED === 'true';

const ownerSharingService = {
  async accounts() {
    return (await axiosInstance.get('/owner-sharing/accounts', options)).data;
  },
  async view(orgId) {
    return (await axiosInstance.get(base(orgId), options)).data;
  },
  async searchCompanies(orgId, query) {
    return (await axiosInstance.get(`${base(orgId)}/companies`, { ...options, params: { q: query } })).data;
  },
  async offer(orgId, input) {
    return (await axiosInstance.post(`${base(orgId)}/shares`, input, options)).data;
  },
  async change(orgId, shareId, input) {
    return (await axiosInstance.put(`${base(orgId)}/shares/${encodeURIComponent(shareId)}`, input, options)).data;
  },
  async approve(orgId, shareId, input) {
    return (await axiosInstance.post(`${base(orgId)}/shares/${encodeURIComponent(shareId)}/approve`, input, options)).data;
  },
  async incoming() {
    return (await axiosInstance.get('/owner-sharing/incoming', options)).data;
  },
  async respond(shareId, action, expectedRevision) {
    return (await axiosInstance.post(`/owner-sharing/incoming/${encodeURIComponent(shareId)}/${action}`,
      { confirmed: true, expectedRevision }, options)).data;
  },
  async searchWashes(query) {
    return (await axiosInstance.get('/owner-sharing/washes', { ...options, params: { q: query } })).data;
  },
  async request(input) {
    const { orgId, ...body } = input;
    return (await axiosInstance.post(`/owner-sharing/requests/${encodeURIComponent(orgId)}`, body, options)).data;
  },
  async end(orgId, shareId, expectedRevision) {
    return (await axiosInstance.post(`${base(orgId)}/shares/${encodeURIComponent(shareId)}/end`,
      { confirmed: true, expectedRevision }, options)).data;
  }
};

export default ownerSharingService;
